import React, { createContext, useContext } from 'react';

const SrpIslandContext = createContext<boolean>(false);

export function useSrpIsland(): boolean {
  return useContext(SrpIslandContext);
}

export const SrpIslandProvider = SrpIslandContext.Provider;
